export default "__VITE_ASSET__BVpiiXez__"